export default __webpack_public_path__ + "static/media/Icons-39.8a9a59e3.png";